wbApp.controller('SurveyDetailCtrl', ['$scope', 'surveySvc',
function ($scope, surveySvc) {

    $scope.modelOrig = angular.copy($scope.model);

    $scope.detailTabs = [
        {
            title: 'TXT_MAIN',
            template: "survey/survey-detail-main-tab.html"
        },
        {
            title: "TXT_LBL_QUESTIONS",
            template: "survey/survey-detail-questions-tab.html",
            paneScrollable: true
        }
    ];

    $scope.detailTabs.activeTab = 0;

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };

    $scope.onQuestionAdd = function () {
        $scope.model.surveyQuestions.push(surveySvc.newQuestion());
    }

    $scope.onQuestionRemove = function (question) {
        var index = $scope.model.surveyQuestions.indexOf(question);
        if (index > -1) {
            $scope.model.surveyQuestions.splice(index, 1);
        }
    }

    $scope.onSurveyTypeChanged = function (question, surveyTypeID) {
        if (surveyTypeID === 3) {
            question.allowCustomNote = false;
        } else {
            question.allowCustomNote = true;
        }
    }

    $scope.isSaving = false;

    $scope.onSurveyDetailSave = function (model) {
        
        $scope.isSaving = true;

        if (!model.surveyID) {
            surveySvc.insert(model, success, error);
        } else {
            surveySvc.update(model, success, error);
        }

        function success() {
            $scope.isSaving = false;
            $scope.onSave();
            $scope.$hide();
        }

        function error(data) {
            $scope.isSaving = false;
            $scope.detailError = data;
        }
    }

}]);
